var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z",
    fill: "url(#paint0_linear_1136_26754)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1163 19.1162C22.5582 19.1162 25.3485 16.3259 25.3485 12.884C25.3485 9.44198 22.5582 6.65169 19.1162 6.65169C15.6742 6.65169 12.884 9.44187 12.8839 12.8838C9.44193 12.8838 6.65169 15.6741 6.65169 19.116C6.65169 22.558 9.44198 25.3483 12.884 25.3483C16.3259 25.3483 19.1161 22.5581 19.1163 19.1162ZM19.1163 19.1162V19.116C19.1163 15.6741 16.3259 12.8838 12.8839 12.8838V12.884C12.8839 16.326 15.6743 19.1162 19.1163 19.1162Z",
    fill: "url(#paint1_linear_1136_26754)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1833 19.0485C19.1473 15.6229 16.3772 12.8528 12.9517 12.8167C12.9877 9.44293 15.7339 6.71911 19.1162 6.71911C22.5209 6.71911 25.281 9.47921 25.281 12.884C25.281 16.2663 22.5571 19.0125 19.1833 19.0485ZM12.8168 12.9515C12.8528 16.3771 15.623 19.1472 19.0485 19.1833C19.0124 22.5571 16.2663 25.2809 12.884 25.2809C9.47921 25.2809 6.7191 22.5208 6.7191 19.116C6.7191 15.7337 9.443 12.9875 12.8168 12.9515ZM19.1837 19.1833C22.6318 19.1471 25.4159 16.3407 25.4159 12.884C25.4159 9.40474 22.5954 6.58428 19.1162 6.58428C15.6595 6.58428 12.8531 9.36827 12.8168 12.8163H12.8165V12.8167C9.36833 12.8529 6.58427 15.6593 6.58427 19.116C6.58427 22.5953 9.40474 25.4157 12.884 25.4157C16.3406 25.4157 19.1471 22.6317 19.1833 19.1837H19.1837V19.1833ZM31.9326 16C31.9326 24.7993 24.7993 31.9326 16 31.9326C7.20068 31.9326 0.0674157 24.7993 0.0674157 16C0.0674157 7.20068 7.20068 0.0674157 16 0.0674157C24.7993 0.0674157 31.9326 7.20068 31.9326 16ZM12.9517 12.9515C16.3027 12.9876 19.0125 15.6974 19.0485 19.0485C15.6974 19.0124 12.9877 16.3026 12.9517 12.9515Z",
    stroke: "#FE8329",
    strokeOpacity: 0.1,
    strokeWidth: 0.134831
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1136_26754",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#B2B2B2",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0003,
    stopColor: "#434341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54919,
    stopColor: "#262625"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1136_26754",
    x1: 25.3561,
    y1: 6.6439,
    x2: 6.64397,
    y2: 25.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.337717,
    stopColor: "#FE8329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681516,
    stopColor: "#FCBF21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEDD8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmni);
export default __webpack_public_path__ + "static/media/omni.6915d2f7835b57debdbb687b5db9d6cd.svg";
export { ForwardRef as ReactComponent };